import { render } from "./OrdersListCard.vue?vue&type=template&id=1d4d581d"
import script from "./OrdersListCard.vue?vue&type=script&lang=js"
export * from "./OrdersListCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__